import "./form-level.scss";

import { Constraint } from "@core/model/constraint.enum";
import { LevelFormSchema } from "@factory/form/form.rule";
import { LabelValue } from "@shared/models/label-value.interface";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import ImageControl from "@shared/ui/hook-form/image-control/image-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";
import { Divider } from "primereact/divider";
import { useFormContext } from "react-hook-form";

type InputFormSchema = LevelFormSchema;
export function FormLevel() {
  const { control } = useFormContext<LevelFormSchema>();
  const constraintOption = [
    {
      label: `${Constraint.AND} (Points & Stamp both deducted)`,
      value: Constraint.AND,
    } as LabelValue,
    {
      label: `${Constraint.OR} (Points OR Stamp will be deducted)`,
      value: Constraint.OR,
    } as LabelValue,
  ];

  return (
    <div id="FormLevel" className="level">
      <ImageControl<InputFormSchema>
        control={control}
        name="file"
        label="Level Photo"
        imagePreviewClass="w-32 h-32"
      />

      <Divider />

      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="points"
        label="Points"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter points"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="stamp"
        label="Stamp"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter stamp"
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name="constraint"
        label="Criteria"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        options={constraintOption}
        placeholder="Enter criteria"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="maxPoints"
        label="Max points"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter max points"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="maxStamp"
        label="Max stamp"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter max stamp"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="maxPointsPerDay"
        label="Max points per day"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter max points per day"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="maxStampPerDay"
        label="Max stamp per day"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter max stamp per day"
      />
    </div>
  );
}

export default FormLevel;
